import React from 'react';
import getSuitCSSClasses from '@/utils/getSuitCSSClasses';
import { getFormattedNumber } from '@ecg-marktplaats/aurora-js-formatters';
import LinkGenerator from '@/client/components/LinkGenerator/LinkGenerator';
import trackingKeys from '@/client/constants/analytics/trackingKeys';
import CATEGORIES_L1 from '@/constants/categories';
import { Radio } from '@hz-design-system/web-ui';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';

type TListItemOneProps = {
  text?: string;
  categories?: {
    l1Category: {
      key: string;
      id: number;
    };
  };
  searchRequestObject: TSearchRequestObject;
  selected?: boolean;
  hidden?: boolean;
  count?: number;
};

type TListItemTwoProps = {
  count?: number;
  hidden?: boolean;
  text?: string;
  categories?: {
    l1Category: TCategory;
    l2Category: TCategory;
  };
  searchRequestObject: TSearchRequestObject;
  selected?: boolean;
};

const l1CategoryIsCars = (l1categoryId) => {
  return l1categoryId === CATEGORIES_L1.CARS;
};

const ListItemOne = ({ text, count, categories, searchRequestObject, hidden, selected }: TListItemOneProps) => {
  const { t } = useI18nContext();
  const removeAllAttributes = !l1CategoryIsCars(categories?.l1Category?.id);
  return (
    <LinkGenerator
      searchRequestObject={searchRequestObject}
      categories={categories}
      removeAllAttributes={removeAllAttributes}
      className={getSuitCSSClasses({
        namespace: 'hz',
        name: 'Level-one',
        custom: `${hidden ? 'hz-hidden' : ''} ${selected ? 'selected' : ''}`,
      })}
      eventAction={trackingKeys.FILTER.EVENT_ACTION}
      eventLabel={trackingKeys.FILTER.EVENT_LABEL.PARENT_CATEGORY}
      tabIndex={-1}
    >
      <Radio
        value={text || ''}
        isChecked={selected || false}
        labelText={t('facets.category.allAds')}
        onChange={(e) => {
          e.preventDefault();
        }}
        // counter={typeof count === 'number' && count >= 0 ? getFormattedNumber(count) : undefined}
      />
    </LinkGenerator>
  );
};

const ListItemTwo = ({ text, count, categories, hidden, searchRequestObject, selected }: TListItemTwoProps) => {
  return (
    <LinkGenerator
      className={getSuitCSSClasses({
        namespace: 'hz',
        name: 'Level-two',
        modifiers: [selected ? 'selected' : ''],
        custom: [hidden ? 'hz-hidden' : ''],
      })}
      searchRequestObject={searchRequestObject}
      categories={categories}
      eventAction={trackingKeys.FILTER.EVENT_ACTION}
      eventLabel={trackingKeys.FILTER.EVENT_LABEL.SINGLE_CATEGORY}
      tabIndex={-1}
    >
      <Radio
        value={text || ''}
        isChecked={selected || false}
        labelText={text}
        counter={typeof count === 'number' && count >= 0 ? getFormattedNumber(count) : undefined}
        onChange={(e) => {
          e.preventDefault();
        }}
      />
    </LinkGenerator>
  );
};

class TreeItem extends React.Component {
  static LevelOne = ListItemOne;

  static LevelTwo = ListItemTwo;
}

export default TreeItem;
